
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Coins, MapPin, Phone, Truck, Star, TreePine } from "lucide-react";
import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

const AchatMetauxCantal = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <SEO 
        title="Achat Métaux Cantal (15) - Rachat Fer Cuivre Aurillac | Groupe Fabre"
        description="Rachat de métaux dans le Cantal : fer, cuivre, aluminium. Service Aurillac, Saint-Flour. Solutions haute altitude, pesée certifiée."
        canonical="/nos-services/achat-metaux/cantal"
        keywords="achat métaux Cantal, rachat cuivre Aurillac, ferraille 15, métaux Saint-Flour"
      />
      <Navbar />
      
      <main className="flex-1 mt-16">
        {/* Hero Section */}
        <div className="bg-gradient-to-r from-blue-800 to-blue-900 text-white py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl">
              <div className="flex items-center mb-4">
                <TreePine className="h-12 w-12 mr-4" />
                <div>
                  <h1 className="text-4xl md:text-5xl font-bold">Achat Métaux Cantal</h1>
                  <p className="text-xl mt-2 opacity-90">Rachat de métaux en haute altitude dans le 15</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Content Section */}
        <div className="py-12 bg-white">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
              <div>
                <h2 className="text-3xl font-bold text-fabre-gray mb-6">
                  Rachat de métaux dans le Cantal (15)
                </h2>
                <p className="text-gray-600 mb-6">
                  <strong>Groupe Fabre Environnement</strong> propose ses services d'achat de métaux 
                  dans tout le <strong>Cantal</strong>. Nous sommes spécialisés dans les interventions 
                  en haute altitude et zones difficiles d'accès à Aurillac, Saint-Flour et dans toutes les communes du département 15.
                </p>
                
                <h3 className="text-xl font-bold text-fabre-gray mb-4">Zones d'intervention Cantal</h3>
                <ul className="space-y-3 mb-8">
                  <li className="flex items-start">
                    <MapPin className="h-5 w-5 text-blue-800 mr-3 mt-1" />
                    <span><strong>Aurillac :</strong> préfecture et bassin</span>
                  </li>
                  <li className="flex items-start">
                    <MapPin className="h-5 w-5 text-blue-800 mr-3 mt-1" />
                    <span><strong>Saint-Flour :</strong> planèze et haute Auvergne</span>
                  </li>
                  <li className="flex items-start">
                    <MapPin className="h-5 w-5 text-blue-800 mr-3 mt-1" />
                    <span><strong>Mauriac :</strong> vallée de la Dordogne</span>
                  </li>
                  <li className="flex items-start">
                    <MapPin className="h-5 w-5 text-blue-800 mr-3 mt-1" />
                    <span><strong>Zones isolées :</strong> intervention spécialisée</span>
                  </li>
                </ul>

                <div className="bg-blue-50 border border-blue-200 p-6 rounded-lg">
                  <h4 className="font-bold text-blue-800 mb-3">Expertise montagne</h4>
                  <ul className="text-blue-700 text-sm space-y-2">
                    <li>• Solutions adaptées aux contraintes d'altitude</li>
                    <li>• Matériel spécialisé pour accès difficiles</li>
                    <li>• Intervention par tous temps</li>
                    <li>• Connaissance du terrain cantalien</li>
                  </ul>
                </div>
              </div>

              <div className="bg-gray-50 p-8 rounded-lg">
                <h3 className="text-2xl font-bold text-fabre-gray mb-6">Service montagne</h3>
                <p className="text-gray-600 mb-6">
                  Notre expertise des contraintes montagnardes nous permet 
                  d'intervenir efficacement dans tout le Cantal, même en zones isolées.
                </p>
                
                <div className="space-y-4 mb-6">
                  <div className="flex items-center">
                    <TreePine className="h-5 w-5 text-blue-800 mr-3" />
                    <span>Spécialiste haute altitude</span>
                  </div>
                  <div className="flex items-center">
                    <Truck className="h-5 w-5 text-blue-800 mr-3" />
                    <span>Véhicules adaptés</span>
                  </div>
                  <div className="flex items-center">
                    <Coins className="h-5 w-5 text-blue-800 mr-3" />
                    <span>Prix attractifs</span>
                  </div>
                  <div className="flex items-center">
                    <Star className="h-5 w-5 text-blue-800 mr-3" />
                    <span>Service garanti</span>
                  </div>
                </div>

                <Link to="/contact" className="block">
                  <button className="w-full px-6 py-3 bg-blue-800 text-white rounded-md font-medium hover:bg-blue-900 transition-colors">
                    Demander un devis Cantal
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default AchatMetauxCantal;
